// extracted by mini-css-extract-plugin
export default {"ButtonPlaceholder":"BYUiGJer","ButtonSkeleton":"otfMK1ln","IconPlaceholder":"nqMfUgx5","Textbox":"LFMS5mSq","TextboxPlaceholder":"i3uJQmYR"};